import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
/**
 * PropertyGroup class
 */

export class PropertyGroup extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getId = () => {
      return this.model.id;
    };

    this.getTitle = () => {
      return this.model.title;
    };

    this.getSort = () => {
      return this.model.sort;
    };

    this.getCreatedAt = () => {
      return this.model.createdAt;
    };

    this.getUpdatedAt = () => {
      return this.model.updatedAt;
    };
  }

  /**
   * Create propertyGroup
   *
   * @param {object} object
   *
   * @return {PropertyGroup}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Create list propertyGroups
   *
   * @param {object} objects
   *
   * @return {Array.<PropertyGroup>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map propertyGroups
   *
   * @param {Array.<object>} objects
   * @param {function(PropertyGroup): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get propertyGroup id
   *
   * @return {number}
   */


}